type Game7Map = {
  intro: string[]
  buttons: {
    groupA: string
    groupB: string
  }
  items: Array<{
    id: string
    label: string
    img: string
    group: string
    message: string
  }>
  errorComments: string[]
}

export const Game7Map: Game7Map = {
  intro: [
    'Často v lese potkávám děti i dospělé, kteří lesu ubližují. Odhazují odpadky nebo dělají hluk a ruší lesní obyvatele. Pomůžeš mi? Ukážeme jim, jak se v lese chovat ohleduplně. ',
    'Roztřiď obrázky na 2 hromádky. Které předměty a chování do lesa patří a které nepatří?',
  ],
  buttons: { groupA: 'Patří', groupB: 'Nepatří' },
  items: [
    // { id: 'trip', label: 'Výlet', img: require('../assets/game7/do_lesa_barva-min.png').default, group: 'A', message: '' },
    {
      id: 'shrooms',
      label: 'Houby',
      img: require('../assets/game7/houby_barva-min.png').default,
      group: 'A',
      message:
        'Houby, borůvky, maliny nebo jahody může sbírat každý návštěvník lesa, pouze však pro svou vlastní potřebu.',
    },
    {
      id: 'catcher',
      label: 'Lapák',
      img: require('../assets/game7/lapak1_barva-min.png').default,
      group: 'A',
      message:
        'Houby, borůvky, maliny nebo jahody může sbírat každý návštěvník lesa, pouze však pro svou vlastní potřebu.',
    },
    // { id: 'defense1', label: 'Ochrana', img: require('../assets/game7/ochrana1_barva-min.png').default, group: 'A', message: '' },
    {
      id: 'defense2',
      label: 'Ochrana 2',
      img: require('../assets/game7/ochrana2_barva-min.png').default,
      group: 'A',
      message: 'Plastové chrániče brání zvěři (srnkám, daňkům, jelenům) okusovat a poškozovat mladé lesní stromky.',
    },
    {
      id: 'defense3',
      label: 'Oplocenka',
      img: require('../assets/game7/oplocenka_barva-min.png').default,
      group: 'A',
      message:
        'Oplocené pasece se říká oplocenka. Chrání sazenice a mladé stromky proti okusování zvěří, např. srnkami.',
    },
    {
      id: 'teacher',
      label: 'Pedagogika',
      img: require('../assets/game7/pedagogika_barva-min.png').default,
      group: 'A',
      message: 'Děti se u lesníka objednaly na akci lesní pedagogiky. Moc se jim v lese líbí. Přijdeš také?',
    },
    {
      id: 'dogOnLeash',
      label: 'Pes na vodítku',
      img: require('../assets/game7/pes_voditkobarva-min.png').default,
      group: 'A',
      message:
        'Pejsek je v lese vítaný, pokud ho jeho pán vede na vodítku. Nemůže pak rušit lesní zvěř ani jiné obyvatele lesa.',
    },
    {
      id: 'tree',
      label: 'Strom',
      img: require('../assets/game7/strom_barva-min.png').default,
      group: 'A',
      message: 'Rozpraskaná kůra stromů svádí k dotýkání, vůně a barvy lesa k prozkoumání. Už jsi to někdy zkusil?',
    },
    {
      id: 'animal',
      label: 'Zvíře',
      img: require('../assets/game7/zvire_barva-min.png').default,
      group: 'A',
      message:
        'Jelen se považuje za „krále našich lesů“. Samice se nazývá laň, mládě kolouch. Zvěři jelení se také říká zvěř vysoká.',
    },
    // { id: 'animal2', label: 'Zvíře', img: require('../assets/game7/zvire1_barva-min.png').default, group: 'A', message: '' },
    {
      id: 'animal3',
      label: 'Zvíře',
      img: require('../assets/game7/zvire2_barva-min.png').default,
      group: 'A',
      message: 'K obyvatelům lesa patří také ptáci, mezi nimi i dravci nebo sovy.',
    },

    {
      id: 'car',
      label: 'Auto',
      img: require('../assets/game7/auto_barva-min.png').default,
      group: 'B',
      message:
        'Víš, že jezdit auty po lese a lesních cestách je zakázáno? Autem mohou při práci do lesa jenom lesníci a lesní dělníci, kteří mají zvláštní povolenku.',
    },
    {
      id: 'cigaret',
      label: 'Cigareta',
      img: require('../assets/game7/cigareta_barva-min.png').default,
      group: 'B',
      message:
        'Cigareta do lesa samozřejmě nepatří. Může způsobit požár, který poničí les a ohrozí obyvatele lesa. Kouření je u nás jednou z nejčastějších příčin vzniku lesních požárů.',
    },
    {
      id: 'bicycle',
      label: 'Kolo',
      img: require('../assets/game7/kolo_barva-min.png').default,
      group: 'B',
      message:
        'Ohleduplní návštěvníci lesa jezdí na kole pouze po lesních cestách. Ne jako tento chlapec, který při jízdě v porostu poškozuje malé semenáčky lesních dřevin a lesní půdu.',
    },
    {
      id: 'bottle',
      label: 'Láhve',
      img: require('../assets/game7/lahve_barva-min.png').default,
      group: 'B',
      message:
        'Líbil by se ti les plný odpadků? Prázdné lahve, obaly od bonbonů nebo sáčky od svačiny patří do popelnice, ne do lesa.',
    },
    {
      id: 'dog',
      label: 'Pes',
      img: require('../assets/game7/pes_barva-min.png').default,
      group: 'B',
      message:
        'Nenechávejte své pejsky běhat v lese bez vodítka. Zvěř je vnímá jako nebezpečné šelmy a nepřátele, bojí se jich. Někdy stačí i jen stopy psa nebo jeho pach v houštích, kde zvěř potřebuje mít klid. Pokud ho nemá, může to pro ni znamenat i smrtelné nebezpečí.',
    },
    {
      id: 'pneu',
      label: 'Pneumatika',
      img: require('../assets/game7/pneumatika-barva-min.png').default,
      group: 'B',
      message:
        'Staré pneumatiky do lesa nepatří. Také určitě raději sbíráš houby v lese, ve kterém za každým pařezem nenarazíš na hromady odpadků a starých pneumatik.',
    },
    {
      id: 'radio',
      label: 'Rádio',
      img: require('../assets/game7/radio_barva-min.png').default,
      group: 'B',
      message:
        'Zbytečný hluk a křik ruší všechny lesní obyvatele, od ptáků a hlodavců přes šelmy a jeleny po divoká prasata. Není příjemný ani člověku.',
    },
    {
      id: 'fire',
      label: 'Táborák',
      img: require('../assets/game7/taborak_barva-min.png').default,
      group: 'B',
      message:
        'Rozdělávat oheň v lese je zakázáno. Lesní požár vznikne během okamžiku, zvláště když je hodně sucho a teplo. Škody způsobené lesními požáry dosahují desítek miliónů korun ročně.',
    },
    {
      id: 'plants',
      label: 'Sázení',
      img: require('../assets/game7/sazeni_barva-min.png').default,
      group: 'B',
      message:
        'Les není zahrada. Není možné, aby si každý do lesa něco zasadil, natož pak cizí rostlinu, jako je palma. Jaké dřeviny je vhodné do kterého lesa vysadit, a jak se o les starat, vědí lesníci - odborníci.',
    },
  ],
  errorComments: [
    'Nene, zkus to jinak.',
    'Vedle jak ta jedle.',
    'Kdepak, zkus to jinak.',
    'Prach a broky, to není ono.',
  ],
}
